export const LOGIN_TOKEN_KEY = 'hoops_token';

const getApiCredentials = {host: 'https://hoops-back-dev.appelloproject.xyz'};

export const catalogImportUri = '/api/products/import';
export const catalogImportProcessUri = '/api/products/import/process';

export default getApiCredentials;
